import { CommonSystemToponomyCrumbs } from '../constants/breadcrumb';

export const CommonToponymyCrumbs = [
  ...CommonSystemToponomyCrumbs,
  {
    name: 'Area di circolazione',
    path: '/sistema/toponomastica/area-di-circolazione',
  },
];
